import { useAuth0 } from "@auth0/auth0-react";
import { IconUserCircle } from "@tabler/icons-react";
import { createFileRoute, useSearch } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import Button from "../components/core/Buttons/Button";
import { useTagManager } from "../hooks/useTagManager";
import { loginSearchSchema } from "../lib/search-params";

export const Route = createFileRoute("/")({
	component: Index,
	validateSearch: (search) => loginSearchSchema.parse(search),
});

function Index() {
	const { t } = useTranslation();
	const search = useSearch({ from: "/" });
	const { loginWithRedirect, error } = useAuth0();

	useTagManager("Step Login");

	return (
		<div className="justify-center flex flex-col items-center max-w-[35rem] m-auto mt-6 px-4">
			{(search.error || error) && (
				<p className="text-red-600 p-4 rounded-md bg-red-100 text-center w-full mt-4">
					{search.error ? t(`${search.error}`) : error?.message}
				</p>
			)}
			<div className="mt-24">
				<div className="text-center">
					<div className="w-14 m-auto mb-4">
						<IconUserCircle
							width={54}
							height={54}
							stroke={1}
						/>
					</div>
					<p className="font-semibold text-3xl mb-5">{"User sign in"}</p>
				</div>
			</div>
			<div className="mb-40 mt-14 mx-auto">
				<Button
					label={"Log in"}
					size="large"
					onClick={() => {
						loginWithRedirect();
					}}
				/>
			</div>
		</div>
	);
}
